import { Box } from "@mui/material";
import { type ReactNode } from "react";
import { Outlet } from "react-router-dom";

import { VisitorManagementSideNav } from "~ui/organisms/VisitorManagementSideNav/VisitorManagementSideNav";
import { VisitorManagementTechSupportDialog } from "~ui/organisms/VisitorManagementTechSupportDialog/VisitorManagementTechSupportDialog";
import { VisitorManagementTopBar } from "~ui/organisms/VisitorManagementTopBar/VisitorManagementTopBar";

export interface VisitorManagementShellTemplateProps {
  isKioskLayout: boolean;
  logoHeight: string;
  onEmergency: () => void;
  onTechSupportClose: () => void;
  onTechSupportOpen: () => void;
  quickResponseModal: ReactNode;
  schoolId: string | undefined;
  schoolName: string;
  techSupportModalLogoHeight: string;
  techSupportOpen: boolean;
}

export function VisitorManagementShellTemplate({
  isKioskLayout,
  logoHeight,
  onEmergency,
  onTechSupportClose,
  onTechSupportOpen,
  quickResponseModal,
  schoolId,
  schoolName,
  techSupportModalLogoHeight,
  techSupportOpen,
}: VisitorManagementShellTemplateProps) {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {quickResponseModal}
      <VisitorManagementTechSupportDialog
        logoHeight={techSupportModalLogoHeight}
        open={techSupportOpen}
        onClose={onTechSupportClose}
      />
      <VisitorManagementTopBar
        isKioskLayout={isKioskLayout}
        logoHeight={logoHeight}
        schoolId={schoolId}
        schoolName={schoolName}
        onEmergency={onEmergency}
      />
      {isKioskLayout ? (
        <Box
          component="main"
          sx={{
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            minHeight: 0,
            minWidth: 0,
            overflow: "hidden",
            overscrollBehavior: "contain",
            p: { sm: 3, xs: 2 },
          }}
        >
          <Outlet />
        </Box>
      ) : (
        <Box sx={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden" }}>
          <VisitorManagementSideNav onEmergency={onEmergency} onTechSupport={onTechSupportOpen} />
          <Box
            component="main"
            sx={{
              flex: "1 1 auto",
              minHeight: 0,
              minWidth: 0,
              overflow: "auto",
              overscrollBehavior: "contain",
              p: 3,
            }}
          >
            <Outlet />
          </Box>
        </Box>
      )}
    </Box>
  );
}
